/**
 * O corte do tutor sobre uma capa, em CSS — tela e celular, cada um o seu.
 *
 * O dono (21/09): *«ao modificar a versão web ele também arrasta a versão
 * mobile, e deveria ser diferente, cada versão com seu enquadramento, corte,
 * zoom e tamanho»*. A caixa do herói muda de proporção em 640 px (8/3 → 4/5 na
 * vitrine, 7/1 → 5/2 na comunidade), e um ponto focal só não serve às duas.
 *
 * O algoritmo é o do editor (`RecorteDoDestaque`, no painel): `object-position`
 * escolhe o que sobra dentro do `cover`, e a escala com `transform-origin` no
 * mesmo ponto é o zoom — o ponto da imagem em x% fica em x% da caixa.
 *
 * Quem escolhe entre os dois é o CSS (`.vst-corte`, em `index.css`), por media
 * query, e não o JS: o mesmo HTML serve à prévia do painel em 390, 900 e 1280
 * sem medir a janela, e sem um quadro com o corte errado antes do `resize`.
 * Aqui só se escrevem as quatro variáveis; o celular sem corte próprio herda o
 * da tela.
 */
export type Corte = { x: number; y: number; zoom: number };

export function estiloDoCorte(
  tela: Corte | null | undefined,
  celular: Corte | null | undefined,
): React.CSSProperties | undefined {
  const t = tela ?? (celular ? { x: 50, y: 50, zoom: 1 } : null);
  if (!t) return undefined;
  const c = celular ?? t;
  return {
    '--corte-tela': `${t.x}% ${t.y}%`,
    '--corte-tela-zoom': t.zoom,
    '--corte-cel': `${c.x}% ${c.y}%`,
    '--corte-cel-zoom': c.zoom,
  } as React.CSSProperties;
}
